import clsx from 'clsx'
import {
  Button,
  Col,
  Modal,
  ModalProps,
  Radio,
  Row,
  Space,
  Text,
} from 'components/common'

type OmittedModalProps = Omit<
  ModalProps,
  'title' | 'width' | 'bodyStyle' | 'footer'
>
export interface ExportModalProps extends OmittedModalProps {}

export const ExportModal = ({
  onCancel,
  onOk,
  ...restProps
}: ExportModalProps): JSX.Element => {
  return (
    <Modal
      title="顧客情報をエクスポートする"
      onCancel={onCancel}
      width={700}
      footer={
        <Space>
          <Button key="back" onClick={onCancel}>
            キャンセル
          </Button>

          <Button type="primary" onClick={onOk}>
            顧客情報をエクスポートする
          </Button>
        </Space>
      }
      {...restProps}
    >
      <Col span={24}>
        <Row>
          <Row>
            <Col className={clsx('mb-12')}>
              <Col span={24}>エクスポートの対象</Col>
              <Col span={24}>
                <Radio.Group>
                  <Col span={24}>
                    <Radio value={1}>
                      <Text>エクスポートの対象</Text>
                    </Radio>
                  </Col>
                  <Col span={24}>
                    <Radio value={2}>
                      <Text>全ての顧客</Text>
                    </Radio>
                  </Col>
                  <Col span={24}>
                    <Radio value={3} disabled={true}>
                      <Text type="secondary">選択済み：0件の顧客</Text>
                    </Radio>
                  </Col>
                </Radio.Group>
              </Col>
            </Col>

            <Col span={24}>エクスポートの種類</Col>
            <Col span={24}>
              <Radio.Group>
                <Col span={24}>
                  <Radio value={1}>
                    {' '}
                    <Text> 現在のページ </Text>
                  </Radio>
                </Col>
                <Col span={24}>
                  <Radio value={2}>
                    <Text>全ての顧客</Text>
                  </Radio>
                </Col>
              </Radio.Group>
            </Col>
          </Row>
        </Row>
      </Col>
    </Modal>
  )
}
